import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, LayoutDashboard, Rocket, CheckCircle } from 'lucide-react';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-br from-industrial-900 to-industrial-800">
      <header className="mb-12 text-center animate-fade-in">
        <div className="inline-block p-1 mb-6 rounded-2xl bg-gradient-to-r from-brand to-brand-dark">
          <div className="px-6 py-2 bg-industrial-900 rounded-xl">
             <span className="text-2xl font-bold tracking-tighter text-brand">DEXTER</span>
             <span className="text-2xl font-light tracking-tighter text-slate-400 ml-2">COMMUNICATIONS</span>
          </div>
        </div>
        <h1 className="text-5xl font-extrabold text-white mb-4 tracking-tight">
          Brand Naming Toolkit
        </h1>
        <p className="text-xl text-industrial-400 max-w-2xl mx-auto font-light">
          The ultimate naming engine for premium identity development. 
          Audited strategy and linguistic precision by <span className="text-brand font-medium">Dexter Communications</span>.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl">
        <Link to="/admin" className="group glass-card p-8 hover:border-brand/50 transition-all duration-300">
          <div className="flex items-start justify-between mb-6">
            <div className="p-3 bg-industrial-700 rounded-lg group-hover:bg-brand/20 transition-colors">
              <Shield className="w-8 h-8 text-brand" />
            </div>
            <span className="text-xs font-mono text-industrial-500 uppercase tracking-widest">Agency Access</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Admin Dashboard</h2>
          <p className="text-industrial-400 mb-6">
            Manage naming briefs, run linguistic audits, and oversee multi-round history.
          </p>
          <div className="flex items-center gap-2 text-brand text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
            Enter Admin Portal →
          </div>
        </Link>

        <Link to="/client" className="group glass-card p-8 hover:border-brand/50 transition-all duration-300">
          <div className="flex items-start justify-between mb-6">
            <div className="p-3 bg-industrial-700 rounded-lg group-hover:bg-brand/20 transition-colors">
              <LayoutDashboard className="w-8 h-8 text-brand" />
            </div>
            <span className="text-xs font-mono text-industrial-500 uppercase tracking-widest">Presentation Mode</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Client Portal</h2>
          <p className="text-industrial-400 mb-6">
            Review final candidates, view rationales, and provide feedback on the shortlists.
          </p>
          <div className="flex items-center gap-2 text-brand text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
            Review Presentation →
          </div>
        </Link>
      </div>

      <footer className="mt-20 border-t border-industrial-800 pt-8 w-full max-w-4xl flex justify-between items-center text-industrial-500 text-sm">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-green-500" /> Syllable Audit</div>
          <div className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-green-500" /> Domain Pro</div>
          <div className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-green-500" /> Linguistic Check</div>
        </div>
        <div>Dexter - Brand Naming Toolkit © 2026</div>
      </footer>
    </div>
  );
}
